import builder from '../builder';
import ConversationChat1 from '../../streamline-icons/light/conversation-chat-1.svg';

export default builder('IconConversationChat1Light', ConversationChat1);
